import { useCallback } from 'react'
import { useFormikContext } from 'formik'
import { ILeadFormModel } from '../../../typings'
import { IDivision } from '@user/store/divisions/typings'

export function useHandlers({ name }) {
  const { setFieldValue } = useFormikContext<ILeadFormModel>()

  const handelChange = useCallback((value: IDivision | null) => {
    setFieldValue(name, value?.id)
  }, [])

  const handelFocus = useCallback(() => {
    setFieldValue('assignmentRuleFieldFocused', true)
  }, [setFieldValue])

  const handelBlur = useCallback(() => {
    setFieldValue('assignmentRuleFieldFocused', false)
  }, [setFieldValue])

  return {
    handelChange,
    handelFocus,
    handelBlur,
  }
}
